import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=4252fe8b&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=4252fe8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252fe8b",
  null
  
)

export default component.exports